import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'src/app/core/auto-unsubscribe';
import { ProjectService } from 'src/app/services/project.service';

import { BaseComponent } from '../base.component';

@Component({
    templateUrl: './index.component.html'
})

@AutoUnsubscribe()
export class IndexComponent extends BaseComponent {
    private subscribe: any[] = [];

    list : any = {};
    loaded = false;

    isVideo : boolean [] = [];

    constructor(
        private projectService: ProjectService,
    ) {
        super();
    }

    ngOnInit() {
        this.getList();
    }

    ngOnDestroy(){
        // $(window).off();
    }

    public getList(): void {
        // this.search.category = category;
        // this.search.type = type;
        let subscribe = this.projectService.main().subscribe(result => {
            console.debug('result', result);
            this.list = result;
            for(let i = 0; i < this.list.length; i++){
                
                if(this.list[i].pcThumb.substring(this.list[i].pcThumb.lastIndexOf(".") + 1, this.list[i].pcThumb.length) == 'mp4'){
                    this.isVideo.push(true);
                }else{
                    this.isVideo.push(false);
                }
            }
            console.debug('isVideo', this.isVideo);
            
            setTimeout(() => {
                // common();
                page.main.introAnimation();
                page.main.mainInter();
                page.main.utilBlock();
                this.loaded = true;
            },300);
            
        }, error => {
            console.error(error);
            alert("오류가 발생했습니다. 관리자에게 문의해주세요.");
        });
        this.subscribe.push(subscribe);
    }


}
declare var page: any;
declare var common: any;
declare var $: any;
